import { FC, createRef, useEffect } from 'react';

import { ExperienceCard } from './experience-card';
import { ExperienceEmptyState } from '@/components/shared/experience-empty-state';
import { ExperienceModel } from '@/logic/services/experiences';
import { GridLegacy as Grid } from '@mui/material';
import { useScrollToItem } from '@/logic/hooks';

interface ExperiencesProps {
  experiences: ExperienceModel[];
  scrolledToExperience: number;
}

export const Experiences: FC<ExperiencesProps> = ({
  experiences,
  scrolledToExperience,
}) => {
  const { scrollToItem } = useScrollToItem();
  const refsList = experiences?.reduce((acc, value) => {
    acc[value.id] = createRef();
    return acc;
  }, {});

  useEffect(() => {
    if (!!scrolledToExperience && !!refsList)
      scrollToItem(refsList[scrolledToExperience]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrolledToExperience, refsList]);

  return (
    <>
      {experiences?.length > 0 ? (
        <Grid container spacing={2}>
          {experiences?.map(experience => (
            <Grid
              key={experience.id}
              item
              mobile={12}
              tablet={6}
              largeDesktop={4}
              ref={refsList[experience.id]}
            >
              <ExperienceCard experience={experience} withoutTitle />
            </Grid>
          ))}
        </Grid>
      ) : (
        <ExperienceEmptyState />
      )}
    </>
  );
};
